import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx } from "react/jsx-runtime";
import List from '../List/List';
import Popover from '../Popover';
const Menu = props => {
  const {
    className = 'menu',
    children,
    listData,
    open = false,
    trigger = 'click',
    position = 'top-center',
    maxwidth,
    maxheight,
    width = 'auto',
    hasArrow = false,
    preventcloseonblur = true,
    fit = 'medium',
    listChange
  } = props;
  return _jsx(Popover, _extends({
    className: className,
    content: _jsx(List, {
      listData: listData,
      noBorder: true,
      onSelect: listChange
    }),
    open: open,
    trigger: trigger,
    position: position,
    maxheight: maxheight,
    width: width,
    hasArrow: hasArrow,
    preventcloseonblur: preventcloseonblur,
    fit: fit,
    maxwidth: maxwidth
  }, {
    children: children
  }));
};
export default Menu;